/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WhoopsRouteImport } from './routes/whoops'
import { Route as StudiesStudyIdPreviewRouteImport } from './routes/studies.$studyId.preview'
import { Route as StudiesStudyIdTranscriptsVideoCodeRouteImport } from './routes/studies.$studyId.transcripts.$videoCode'

const WhoopsRoute = WhoopsRouteImport.update({
  id: '/whoops',
  path: '/whoops',
  getParentRoute: () => rootRouteImport,
} as any)
const StudiesStudyIdPreviewRoute = StudiesStudyIdPreviewRouteImport.update({
  id: '/studies/$studyId/preview',
  path: '/studies/$studyId/preview',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/studies.$studyId.preview.lazy').then((d) => d.Route),
)
const StudiesStudyIdTranscriptsVideoCodeRoute =
  StudiesStudyIdTranscriptsVideoCodeRouteImport.update({
    id: '/studies/$studyId/transcripts/$videoCode',
    path: '/studies/$studyId/transcripts/$videoCode',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/studies.$studyId.transcripts.$videoCode.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/whoops': typeof WhoopsRoute
  '/studies/$studyId/preview': typeof StudiesStudyIdPreviewRoute
  '/studies/$studyId/transcripts/$videoCode': typeof StudiesStudyIdTranscriptsVideoCodeRoute
}
export interface FileRoutesByTo {
  '/whoops': typeof WhoopsRoute
  '/studies/$studyId/preview': typeof StudiesStudyIdPreviewRoute
  '/studies/$studyId/transcripts/$videoCode': typeof StudiesStudyIdTranscriptsVideoCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/whoops': typeof WhoopsRoute
  '/studies/$studyId/preview': typeof StudiesStudyIdPreviewRoute
  '/studies/$studyId/transcripts/$videoCode': typeof StudiesStudyIdTranscriptsVideoCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/whoops'
    | '/studies/$studyId/preview'
    | '/studies/$studyId/transcripts/$videoCode'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/whoops'
    | '/studies/$studyId/preview'
    | '/studies/$studyId/transcripts/$videoCode'
  id:
    | '__root__'
    | '/whoops'
    | '/studies/$studyId/preview'
    | '/studies/$studyId/transcripts/$videoCode'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  WhoopsRoute: typeof WhoopsRoute
  StudiesStudyIdPreviewRoute: typeof StudiesStudyIdPreviewRoute
  StudiesStudyIdTranscriptsVideoCodeRoute: typeof StudiesStudyIdTranscriptsVideoCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/whoops': {
      id: '/whoops'
      path: '/whoops'
      fullPath: '/whoops'
      preLoaderRoute: typeof WhoopsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studies/$studyId/preview': {
      id: '/studies/$studyId/preview'
      path: '/studies/$studyId/preview'
      fullPath: '/studies/$studyId/preview'
      preLoaderRoute: typeof StudiesStudyIdPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studies/$studyId/transcripts/$videoCode': {
      id: '/studies/$studyId/transcripts/$videoCode'
      path: '/studies/$studyId/transcripts/$videoCode'
      fullPath: '/studies/$studyId/transcripts/$videoCode'
      preLoaderRoute: typeof StudiesStudyIdTranscriptsVideoCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  WhoopsRoute: WhoopsRoute,
  StudiesStudyIdPreviewRoute: StudiesStudyIdPreviewRoute,
  StudiesStudyIdTranscriptsVideoCodeRoute:
    StudiesStudyIdTranscriptsVideoCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
